import React, { useMemo, useState } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, StepperItem } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        await localStorage.setItem( "link", "client_audit_feedback" )
        await localStorage.setItem( "applicationId", record.value )
        return window.location.reload()
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

const ProgressField = record => {
    console.log( '%',record.value )
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

export default function MyLicenses( ) {
  const ApplicationColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Business Trading Name",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
      Header: "Annual Income",
      accessor: "annual_income"
    },
    {
      Header: "Application Progress",
      accessor: "progress",
      Cell: ProgressField
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ActionField
    }
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )
  const [itcoApplicationsLevel, setItcoApplicationsLevel] = useState('0'); 
  const [ levelRecords, setLevelRecords ] = useState( [] )

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading, itcoApplicationsLevel ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
        const results = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            scheduled_action: result.scheduled_action,
            scheduled_date: result.scheduled_date,
            client_reaction_to_audit: result.client_reaction_to_audit,
            id: result.id
          }
        } ).filter( record => { 
          return record.email_address?.toLowerCase() === localStorage.getItem( "email" )?.toLowerCase() && record.issued_on !== null
      } )

      //update the state
      setRecords( results )
      //setLoading( false )
      }
    } catch (error) {
      alert( "Server error occurred." )
      //setLoading( false )
    }
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`My Certificates`}
            </div>
            <div className="flex flex-col justify-center w-full bg-white">
              
                <Table 
                  rightButton={false}
                  rightBtnCallback={ () => {}}
                  rightButtonLabel={null}
                  label="Application Details"
                  columns={ApplicationColumns}
                  data={records}
                  hidePagination={false}
                  exportToExcel={() => {}}
                  exportToCSV={() => {}}
                />
            </div>
          </div>
        </div>
    </Wrapper>
  )
}